import { Injectable } from '@angular/core';
import {Endpoints} from "../../customs/endpoints";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {CommonResponse} from "../../customs/_models/Response";
import { Observable, catchError, of } from 'rxjs';
import { RapportHistory } from '../../customs/_models/rapport-dto';

@Injectable({
  providedIn: 'root'
})
export class RapportService {

    constructor(
        private endpoints: Endpoints,
        private http : HttpClient) { }


    fetchAllRapport(){
        console.log(this.endpoints.rapport_endpoint)
        return this.http.get<CommonResponse>(this.endpoints.rapport_endpoint)
    }

    delete(id: number) {
        return this.http.delete<boolean>(`${this.endpoints.rapport_endpoint}/${id}`)
    }

    public total(){
        return this.http.get<{ success: boolean, message: string, data: number }>(this.endpoints.rapport_endpoint + '/totalRapport');
      }

      updateRapport(id: number, rapportData: any) {
        return this.http.put<CommonResponse>(
          `${this.endpoints.rapport_endpoint}/${id}`,
          rapportData,
          {
            headers: new HttpHeaders({
              'Content-Type': 'application/json'
            })
          }
        );
      }
      signRapport(rapportId: number): Observable<any> {
        return this.http.post(`${this.endpoints.rapport_endpoint}/${rapportId}/sign`, {});
      }
      reviserRapport(rapportId: number): Observable<any> {
        return this.http.post(`${this.endpoints.rapport_endpoint}/${rapportId}/reviser`, {});
      }
      downloadRapports(rapportId: number): Observable<Blob> {
        const url = `${this.endpoints.rapport_endpoint}/${rapportId}/pdf`; // Remplacez par l'URL de l'API
        return this.http.get(url, { responseType: 'blob' }); // Le type de la réponse est blob pour gérer le PDF
    }
    downloadRapport(rapportId: number): Observable<Blob> {
        const url = `${this.endpoints.rapport_endpoint}/download/${rapportId}`; // Remplacez par l'URL de l'API
        return this.http.get(url, { responseType: 'blob' }); // Le type de la réponse est blob pour gérer le PDF
    }
  getSampleIdsByRapportId(rapportId: number): Observable<number[]> {
    return this.http.get<number[]>(`${this.endpoints.rapport_endpoint}/${rapportId}/samples`);
  }
  getRapportHistory(rapportId: number): Observable<RapportHistory[]> {
    return this.http.get<RapportHistory[]>(`${this.endpoints.rapport_endpoint}/${rapportId}/histories`);
  }
  // service.ts
  downloadPdf(id: number): Observable<Blob> {
    return this.http.get(`${this.endpoints.rapport_endpoint}/history/${id}/pdf`, { responseType: 'blob' });
  }

  getChartData(duration: string): Observable<any[]> {
    console.log('Fetching chart data for duration:', duration);
    return this.http.get<any[]>(`${this.endpoints.rapport_endpoint}/data?duration=${duration}`).pipe(
      catchError(err => {
        console.error('Error fetching chart data:', err);
        return of([]); // Retourner un tableau vide en cas d'erreur
      })
    );
  }
}
